module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#technology",
      toString: function () {
        return this.url;
      }
    }